const locales = [{ languageTag: 'vi-VN', countryCode: 'VN', languageCode: 'vi', isRTL: false }];

export const getLocales = () => locales;
export const getCountry = () => 'VN';
export const getCalendar = () => 'gregorian';
export const getTimeZone = () => 'Asia/Ho_Chi_Minh';
export const getNumberFormatSettings = () => ({ decimalSeparator: ',', groupingSeparator: '.' });
export const getTemperatureUnit = () => 'celsius';
export const uses24HourClock = () => true;
export const usesMetricSystem = () => true;
export const addEventListener = () => ({ remove: () => {} });
export const removeEventListener = () => {};

export default {
  getLocales,
  getCountry,
  getCalendar,
  getTimeZone,
  getNumberFormatSettings,
  getTemperatureUnit,
  uses24HourClock,
  usesMetricSystem,
  addEventListener,
  removeEventListener
};
